import t from "./internal/_curry3.mjs";
import u from "./internal/_xReduce.mjs";
import c from "./internal/_xwrap.mjs";
var m = /* @__PURE__ */ t(function(r, o, e) {
  return u(typeof r == "function" ? c(r) : r, o, e);
});
const i = m;
export {
  i as default
};
